import { Field, Form } from 'react-final-form';
import Input from '../../atoms/Input/input';
import {
  composeValidators,
  minLengthValidator,
  mustbeAlphaNumeric,
  requiredFieldValidator,
  ifscValidator
} from '../../common/Utility/validator';
import Button from '../../atoms/Button/Button';
import {
  downloadEft,
  // fetchByIfsc,
  submitBankDetails,
  uploadEft
} from '../../../api/apiControllers/team.onboarding';
import { testIds } from '../../../constants/testId';
import { useEffect, useState } from 'react';
import BankDetailModal from './BankDetailsModal';
import { proceedToNextTask } from '../CompanyProfile/fetchCompanyData';
import {
  downloadBase64,
  getEncryptedMessage,
  getFromSessionStorage,
  loadTimeInterval
} from '../../common/Utility/Utility';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { sendClickStreamEvent } from '../../common/Utility/Analytics';
import './bankDetails.scss';
import validationMessage from '../../common/Utility/validationMessage';
import FileUplaod from '../../atoms/FileUpload';
import ButtonComponent from '../../atoms/Button/Button';
import { getDashboardData } from '../../../api/DashboardAPI';
import { setUserPartnershiDetails } from '../../../redux/actions/actions';

const BankDetails = ({ companyProfileState, userPartnershipDetail, setUserPartnershipDetails }) => {
  // const [ifscData, setIfscData] = useState(null);
  const [show, setShow] = useState(false);
  const [bankDetailsTimeTracking, setBankDetailsTimeTracking] = useState(null);
  const [bankDetailResponse, setBankDetailResponse] = useState(null);
  const [formData, setFormData] = useState(null);
  const [file, setFile] = useState(null);
  const [blankCheque, setBlankCheque] = useState(null);
  const [userDetail, setUserDetail] = useState();
  const [updateBankDetails, setUpdateBankDetails] = useState(false)
  let selectedPartnership = JSON.parse(getFromSessionStorage('selectedPartnership'));
  let navigate = useNavigate();

  const fetchTasksData = async () => {
    try {
      let selectedPartnership = JSON.parse(getFromSessionStorage('selectedPartnership'));
      const dashboardData = await getDashboardData({
        'partnership-id': selectedPartnership.id
      });
      setUserPartnershipDetails(dashboardData);

    } catch (error) {
      console.log(error);
    }
  };

  const submitDetails = async (values) => {
    const timeSpent = loadTimeInterval(bankDetailsTimeTracking);
    const { tradeName } = companyProfileState;
    try {
      let resp = await submitBankDetails({
        // ...values,
        // bankAddress: ifscData.address,
        // bankName: ifscData.bank,
        // accountType: "SAVING",
        //companyUuid: '62e26ea2ffcaccbc4838a172',
        bankAccountNumber: getEncryptedMessage(values['bankAccountNumber']),
        ifsc: values['ifscCode'] && values['ifscCode'].toUpperCase(),
        // verificationStatus: "COMPLETED",
        isActive: 'true',
        accountHolderName: tradeName
      });
      setBankDetailResponse({ ...resp, ...values });
      sendClickStreamEvent({ eventAction: 'BANK_DETAILS_TIME', loadTimeInMilliseconds: timeSpent });
      setBankDetailsTimeTracking(null);
      setShow(true);
    } catch (e) {
      if (e?.response?.data?.displayMessage.includes("You have exceeded the maximum number of penny drop attempts")) {
        fetchTasksData()
        setUpdateBankDetails(false)
      }
      console.log(e);
    }
  };

  const validateConfirmAccount = (values) => {
    return (
      values.bankAccountNumber &&
      values.bankAccountNumber.match(/^[a-zA-Z0-9]+$/) &&
      values.bankAccountNumber === values.confirmBankAccountNumber &&
      values.bankAccountNumber.length > 8 &&
      values.confirmBankAccountNumber.length > 8
    );
  };

  // const getIfscData = async (ifsc) => {
  //   try {
  //     let data = await fetchByIfsc(ifsc);
  //     setIfscData(data);
  //   } catch (e) {
  //     setIfscData(null);
  //     console.log(e);
  //   }
  // };

  const getInitialValues = () => {
    let { bankDetails, tradeName } = companyProfileState;
    if (bankDetails && bankDetails[0]) {
      let ifsc = bankDetails[0].ifscCode;
      // !ifscData && getIfscData(ifsc);
      return {
        bankAccountNumber: bankDetails[0].accountNumber,
        confirmBankAccountNumber: bankDetails[0].accountNumber,
        ifscCode: ifsc,
        accountHolderName: bankDetails[0].beneficiaryName
      };
    } else {
      return { accountHolderName: tradeName };
    }
  };

  const formVisibility = () => {
    if (updateBankDetails) {
      return true
    }
    if (userDetail && userDetail.eftFormEnabled && !userDetail.eftFormUploaded) {
      return false
    }
    else if (userDetail && !userDetail.eftFormEnabled && userDetail.eftFormUploaded) {
      return false
    }
    return true
  }

  const getUploadedDate = (date) => {
    if (date) {
      const timestamp = date;
      const newDate = new Date(timestamp * 1000);
      return newDate.toLocaleDateString();
    }
  }


  let uploadFile = async () => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('blankCheque', blankCheque);
    await uploadEft({ partnershipId: selectedPartnership.id }, formData);
    window.location.reload();
  };

  useEffect(() => {
    if (userPartnershipDetail?.partnerShipDetails) {
      setUserDetail(userPartnershipDetail.partnerShipDetails)
    }
  }, [userPartnershipDetail]);

  useEffect(() => {
    if (companyProfileState) {
      setFormData(getInitialValues());
    }
  }, [companyProfileState]);

  return (
    <div className={'bankDetail'} data-testid={testIds['bank-details-component']}>
      {formVisibility() && (
        <Form
          onSubmit={(values) => submitDetails(values)}
          initialValues={formData}
          render={({ handleSubmit, values, hasValidationErrors }) => (
            <form onSubmit={handleSubmit} noValidate>
              <Field
                data-testid={testIds['bank-details-account']}
                required={true}
                label="Bank Account Number"
                component={Input}
                type="password"
                name="bankAccountNumber"
                key="bankAccountNumber"
                maxLength={18}
                validate={composeValidators([
                  requiredFieldValidator,
                  mustbeAlphaNumeric('Account Number'),
                  minLengthValidator(8, 'Account Number')
                ])}
                onChange={() => {
                  if (!bankDetailsTimeTracking) {
                    setBankDetailsTimeTracking(new Date().getTime());
                  }
                }}
              />
              <div>
                <Field
                  data-testid={testIds['bank-details-account-confirm']}
                  required={true}
                  label="Confirm Bank Account Number"
                  component={Input}
                  name="confirmBankAccountNumber"
                  key="confirmBankAccountNumber"
                  maxLength={18}
                  isBigCheckedIcon={validateConfirmAccount(values)}
                  validate={composeValidators([
                    requiredFieldValidator,
                    mustbeAlphaNumeric('Account Number'),
                    minLengthValidator(8, 'Account Number')
                  ])}
                />
                {values.bankAccountNumber &&
                  values.confirmBankAccountNumber &&
                  !validateConfirmAccount(values) && (
                    <span className="confirm-act-error">{validationMessage.ACT_MISMATCH}</span>
                  )}
              </div>
              <Field
                required={true}
                data-testid={testIds['bank-details-account-name']}
                label="Account Holder's Name"
                component={Input}
                maxLength={80}
                isDisable={true}
                name="accountHolderName"
                key="accountHolderName"
                validate={composeValidators([requiredFieldValidator])}
              />
              <Field
                data-testid={testIds['bank-details-ifsc']}
                required={true}
                label="IFSC Code"
                component={Input}
                name="ifscCode"
                key="ifscCode"
                maxLength={11}
                validate={composeValidators([requiredFieldValidator, ifscValidator])}
              />

              <div className="actions">
                <Button
                  variant="primary"
                  disabled={hasValidationErrors || !validateConfirmAccount(values)}
                  type="submit"
                  btnText="Submit"
                />
              </div>
            </form>
          )}
        />
      )}
      {userDetail?.eftFormEnabled && !updateBankDetails && (
        <div className="eftSection">
          {userDetail?.eftFormRejected && <h3> Approver has rejected the Eft form.</h3>}
          <h3>{!userDetail?.eftFormRejected && 'Penny Drop is successfull but trade name is not matched with beneficiary name.'} Please upload EFT form {userDetail?.eftFormRejected && 'or'} {userDetail?.eftFormRejected && <span style={{ textDecoration: "underline", cursor: "pointer", color: "#027bfc" }} onClick={() => setUpdateBankDetails(true)}>Click here</span>} {userDetail?.eftFormRejected && 'to update bank details.'}</h3>
          <div
            className="download"
            onClick={async () => {
              const resp = await downloadEft({ partnershipId: selectedPartnership.id });
              downloadBase64(resp, 'eft' + '.pdf');
            }}>
            Download EFT Form
          </div>
          <div className="upload">
            <div className="addnUpload">
              <FileUplaod
                required={true}
                onChange={({ value }) => {
                  setFile(value);
                }}
                label="Upload EFT form"
                extentions={['pdf', 'jpeg', 'jpg', 'png']}
                fileSize="5 MB"
                accept=".pdf, .jpeg, .jpg, .png"
              />
              <FileUplaod
                required={true}
                onChange={({ value }) => {
                  setBlankCheque(value);
                }}
                label="Upload Cancelled Cheque"
                extentions={['pdf', 'jpeg', 'jpg', 'png']}
                fileSize="5 MB"
                accept=".pdf, .jpeg, .jpg, .png"
              />
            </div>
          </div>
          <div className="submit">
            <ButtonComponent
              variant="primary-black"
              disabled={
                (!file || !blankCheque)
              }
              onClick={() => uploadFile()}
              btnText="Submit"
            />
          </div>

        </div>
      )}
      {userDetail?.eftFormUploaded &&
        <div className="eftSection">
          <h3>EFT form is uploaded on {getUploadedDate(userDetail?.eftFormUploadedDate)} and same is pending for approval.</h3>
        </div>}
      {show && (
        <BankDetailModal
          bankDetailResponse={bankDetailResponse}
          onProcced={() => {
            proceedToNextTask(navigate);
          }}
          setShow={setShow}
        />
      )}
    </div>
  );
};

BankDetails.propTypes = {
  companyProfileState: PropTypes.object,
  userPartnershipDetail: PropTypes.object,
  setUserPartnershipDetails: PropTypes.func
};

const mapStateToProps = (state) => ({
  companyProfileState: state.companyProfileState,
  userPartnershipDetail: state.userPartnerShipDetail
});

const mapDispatchToProps = (dispatch) => ({
  setUserPartnershipDetails: (data) => dispatch(setUserPartnershiDetails(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(BankDetails);
